module.exports = __webpack_public_path__ + "static/media/Dan_Hand-01.1fceb247.svg";